<template>
  <div class="loading" :style="[{width: width + 'px'},{height: height + 'px'}]">
    <div class="mask"></div>
    <div class="cont">{{msg}}</div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    width: Number,
    height: Number,
    msg: {
      type: String,
      default: '数据加载中...'
    },
  },
  data () {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
   
  }
}
</script>

<style lang="scss">
.loading{
  width: 200px;
  height: 120px;
  position: fixed;
  top:  50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  border-radius: 16px;
  .mask{
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
    border-radius: 16px;
  }
  .cont{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    top:  50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    font-size: 15px;
    color: #fff;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue